import { render } from "./SplitResizer.vue?vue&type=template&id=0b40027b&scoped=true"
import script from "./SplitResizer.vue?vue&type=script&lang=js"
export * from "./SplitResizer.vue?vue&type=script&lang=js"

import "./SplitResizer.vue?vue&type=style&index=0&id=0b40027b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b40027b"]])

export default __exports__